import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Settings } from "lucide-react";
import { PlaceholderPage } from "@/components/vroom/placeholder-page";
import type { RoleKind } from "@/components/vroom/role-pill";

interface SessionUser {
  name: string;
  email: string;
  role?: RoleKind;
}

export const Route = createFileRoute("/_authed/admin/app-settings")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string } }).user;
    if (user?.role !== "super_admin") throw redirect({ to: "/dashboard" });
  },
  component: AppSettingsAdmin,
});

function AppSettingsAdmin() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext() as { user: SessionUser };
  return (
    <PlaceholderPage
      user={{ name: user.name, role: "super_admin" }}
      section="admin"
      activeKey="app-settings"
      breadcrumb={<>{t("admin.app-settings.breadcrumb")}</>}
      title={t("admin.app-settings.title")}
      icon={<Settings size={48} />}
    />
  );
}
